import { Box, Flex, FloraTypography } from '@grupoboticario/flora-react'

import * as S from './EventsStatusTag.styles'

export const eventsStatusTagVariants = {
  ACTIVE: { color: '$success-standard', text: 'Ativo' },
  INACTIVE: { color: '$nonInteractiveAuxiliar', text: 'Inativo' },
  PROGRAMMED: { color: '$9', text: 'Programado' },
  FINISHED: { color: '$nonInteractiveAuxiliar', text: 'Finalizado' }
}

const EventsStatusTag = ({ status = 'ACTIVE' }) => (
  <Flex align="center" gap="$3">
    <Box css={S.getDotWithColorCss(eventsStatusTagVariants[status]?.color || '$error-standard')} />
    <FloraTypography css={S.getTextColorCss(eventsStatusTagVariants[status]?.color)} fontSize="bodySmallStandard">
      {eventsStatusTagVariants[status]?.text}
    </FloraTypography>
  </Flex>
)

export default EventsStatusTag
